module.exports = __webpack_public_path__ + "80573a238e325ffba0e8c1b5cd5efb6a.png";